import { City } from "@fitness-force/models";

export const CONST_CITIES: City[] = [
    { "id": 1, "name": "mumbai", "code": "Mum", "state_code": "MH", "state_id": 1 },
    { "id": 2, "name": "pune", "code": "PU", "state_code": "MH", "state_id": 1 },
    { "id": 3, "name": "latur", "code": "LTR", "state_code": "MH", "state_id": 1 },
    { "id": 4, "name": "New Delhi`", "code": "NDL", "state_code": "DL", "state_id": 2 }
];